import SJNoData from '@/components/SJNoData'
import { couponList } from '@/services/payment'
import { Coupon, CouponListRes } from '@/services/types/payment'
import { InfiniteScroll, PullToRefresh } from 'antd-mobile'
import dayjs from 'dayjs'
import { useEffect, useRef, useState } from 'react'
import Bg1 from './bg1.png'
import Bg2 from './bg2.png'
import './index.less'

const Status = ['待使用', '锁定中', '已使用', '已过期', '已作废']

const CouponList = () => {
  document.title = '我的优惠券'
  const pageRef = useRef(1)
  const sizeRef = useRef(10)
  const [hasMore, setHasMore] = useState(false)
  const [coupons, setCoupons] = useState<Coupon[]>([])

  const fetchCouponList = async (page = 1, size = sizeRef.current) => {
    try {
      const res = (await couponList({ page, size })) as unknown as CouponListRes
      console.log('fetchCouponList', res.list)
      if (page === 1) {
        setCoupons(res.list)
      } else {
        setCoupons(coupons.concat(res.list))
      }
      pageRef.current = res.page
      setHasMore(res.pageTotal > res.page)
    } catch (error) {}
  }

  useEffect(() => {
    fetchCouponList()
  }, [])

  const fetchMore = async () => {
    hasMore && (await fetchCouponList(pageRef.current + 1))
  }

  return (
    <div className="page coupon-list">
      <PullToRefresh onRefresh={fetchCouponList}>
        <div className="main">
          {coupons.map((item) => (
            <div className={`coupon ${item.status > 0 && 'disabled'}`} key={item.useCouponCode}>
              <div className="top">
                <div className="symbol">¥</div>
                <div className="number">{item.couponAmount}</div>
                <div className="coupon-info">
                  <div className="desc">{item.desc}</div>
                  <div className="name">{item.couponName}</div>
                </div>
                <img className="bg" src={item.status === 0 ? Bg1 : Bg2} alt="" />
              </div>
              <div className="bottom">
                <div className="date">
                  有效期至：{dayjs(item.effectiveEndTime).format('YYYY-MM-DD')}
                </div>
                <div className="status">{Status[item.status]}</div>
              </div>
            </div>
          ))}
          {coupons.length ? (
            <InfiniteScroll loadMore={fetchMore} hasMore={hasMore}></InfiniteScroll>
          ) : (
            <SJNoData />
          )}
        </div>
      </PullToRefresh>
    </div>
  )
}

export default CouponList
